/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthorableComponent } from '@core/aem/models/authorable-component.model';
import { CoverageMapAuthorable } from './models/coverage-map-authorable.interface';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfig } from '@root/app.config';
@Component({
  selector: 'tmo-coverage',
  templateUrl: './coverage-map-authorable.component.html',
})
export class CoverageMapAuthorableComponent
  extends AuthorableComponent<CoverageMapAuthorable>
  implements OnInit, OnDestroy
{
  /**
   * Stores the url for the map to be displayed
   */
  @Input() public url: String;
  /**
   * Stores the height for the iframe that will display map
   */
  @Input() public height: String;
  /**
   * Stores the width for iframe that will display map
   */
  @Input() public width: String;
  /**
   * Stores the flag to check web channel
   */
  //  public isWeb: boolean;
  /**
   * Stores tag config for coverage map web kit
   */
  public coverageMapTag: string;
  /**
   * Stores css url comming from AEM content
   */
  public cssUrls: string[];
  constructor(
    public sanitizer: DomSanitizer,
    private appConfig: AppConfig
  ) {
    super();
  }

  /**
   * loads the initial state of coverage map authorable component
   */
  public ngOnInit(): void {
    // if (this.isWeb) {
    const coverageMapConfig = this.appConfig.getConfig('coverageMap');
    if (coverageMapConfig) {
      const coverageMapTag = coverageMapConfig.tag;
      this.coverageMapTag = coverageMapTag
        ? `<${coverageMapTag.tag} kit-type="${coverageMapTag['kit-type']}" client-id="${coverageMapTag['client-id']}" variation="${coverageMapTag.variation}"></${coverageMapTag.tag}>`
        : '';
    }
    // }
  }

  /**
   * Component lifecycle hook to destroy the component
   */
  public ngOnDestroy(): void {
    //  if (this.isWeb && this.cssUrls && this.cssUrls.length) {
    if (this.cssUrls && this.cssUrls.length) {
      this.removeLinkTag();
    }
  }

  /**
   * Method to set data in CoverageMapAuthorable
   * @param data : this will store the data that need to be set in CoverageMapAuthorable
   * @returns void
   */
  public setData(data: CoverageMapAuthorable): void {
    // this.isWeb = SETTINGS.CHANNEL.toLocaleLowerCase() === CHANNELS.WEB;
    if (this.validate(data)) {
      this.url = data.url;
      this.height = data.height;
      this.width = data.width;
      this.cssUrls = data.cssUrls;
      this.createElements();
    }
  }

  /**
   * Check if the data is valid, should throw an error if the input doesn't match designated fields
   * @param data : data that needs to be validated
   * @returns boolean
   */
  public validate(data: CoverageMapAuthorable): boolean {
    //  if (!data.url && !this.isWeb) {
    //    throw new Error(`Invalid options for text ${data}: Required fields [text]`);
    //  }
    return true;
  }

  /**
   * Method to set css link in index file
   * @param cssUrls : this will store the css links that need to be set in head tag
   * @returns void
   */
  private createElements(): void {
    // if (this.isWeb && this.cssUrls && this.cssUrls.length) {
    if (this.cssUrls && this.cssUrls.length) {
      this.cssUrls.forEach((href: string) => {
        let element;
        if (href) {
          element = <HTMLLinkElement>document.createElement('LINK');
          element.rel = 'stylesheet';
          element.href = href;
          document.head.appendChild(element);
        }
      });
    }
  }

  /**
   * Method to remove coverage map css link in index file
   * @returns void
   */
  private removeLinkTag(): void {
    const links = document.head.getElementsByTagName('link');
    for (const link in links) {
      if (links.hasOwnProperty(link)) {
        this.cssUrls.forEach((href: string) => {
          if (links[link].href === href) {
            document.head.removeChild(links[link]);
          }
        });
      }
    }
  }
}
